export default () => {
  let buttonGrouped = document.querySelectorAll(".btn-group");
  //if find btn group
  if(buttonGrouped) {
    //all
    let buttonGroupedRadio = document.querySelectorAll(".btn-group input[type=radio]");

    for (let ii = 0 ; ii  < buttonGrouped.length ; ii++) {
      buttonGrouped[ii].addEventListener('focus', (e) => {verifChecked(e)});
    }

    for (let ii = 0 ; ii  < buttonGroupedRadio.length ; ii++) {
      toggleParentRadio(buttonGroupedRadio[ii]);
      buttonGroupedRadio[ii].addEventListener('change', (e) => {onRadioChange(e)});
    }

  }
}

//check if children are checked
function verifChecked(e){
  e.preventDefault();
  let input = e.target.firstElementChild;
  // toggle checked
  input.checked = !input.checked ;
}

//change event on radio
function onRadioChange(e) {
  toggleParentRadio(e.target);
}

function toggleParentRadio(radio){
  if (radio.checked) {
    let group = radio.parentElement.parentElement;

    for(let ii = 0 ; ii < group.children.length ;ii++){
      group.children[ii].classList.remove("js-is--active");
    }

    radio.parentElement.classList.add("js-is--active");
  }
}

